import React from 'react';
import classnames from 'classnames';

import style from '../forecasting-grid.module.less';

/**
 * Forecasting grid specific numeric column component
 * @param {object} props - Component props
 * @param {number} props.value - Numeric value to display
 * @param {boolean} [props.showUpsell] - Whether to show the upsell mode (blur values)
 * @param {string} [props.upsellPlaceholder] - Custom placeholder to show when in upsell mode
 * @param {(value: number) => string} [props.formatter] - Custom formatter function for the value
 * @returns {React.ReactElement} The rendered forecasting grid numeric column component
 */
export const ForecastingGridNumericColumn = ({ value, showUpsell = false, upsellPlaceholder = null, formatter = null }) => {
  // If in upsell mode and a custom placeholder is provided, use it
  if (showUpsell && upsellPlaceholder !== null) {
    return <div className={classnames(style['numeric-cell'], style['blurred-value'])}>{upsellPlaceholder}</div>;
  }

  const displayValue = formatter ? formatter(value) : value;

  return (
    <div
      className={classnames(style['numeric-cell'], {
        [style['blurred-value']]: showUpsell,
      })}
    >
      {displayValue}
    </div>
  );
};
